module.exports = __webpack_public_path__ + "static/media/lightbulb-exclamation.2c1ffaa1.svg";